import React from 'react';

import { REFUND_METHOD_CREDITS, REFUND_METHOD_DEFAULT, REFUND_METHOD_MANUAL } from '~/consts/refund';

import useCurrentBrand from '~/hooks/useCurrentBrand';

import RefundMethodField from './RefundMethodField';
import { RefundMethods } from './RefundV2/Utils/RefundUtils';

const NON_LE_CREDIT_BRANDS = ['zoomzoom'];
const LATITUDE_METHODS = [REFUND_METHOD_CREDITS, REFUND_METHOD_MANUAL];
const REFUND_METHODS: ReadonlyArray<RefundMethods> = [
  REFUND_METHOD_DEFAULT,
  REFUND_METHOD_CREDITS,
  REFUND_METHOD_MANUAL,
];

interface Props {
  order: App.Order;
  methods: ReadonlyArray<string>;
  refund_method?: string;
  hasLatitudePayment?: boolean;
  handleValueChange: (event: { target: { name: string; value: string } }) => void;
}

export default function RefundMethod({ order, methods, refund_method, hasLatitudePayment, handleValueChange }: Props) {
  const brand = useCurrentBrand();
  const permittedMethods = hasLatitudePayment
    ? LATITUDE_METHODS
    : methods.filter((method) => method !== REFUND_METHOD_CREDITS || !NON_LE_CREDIT_BRANDS.includes(brand));
  // Preserve the legacy display order and ignore unsupported methods.
  const allowedMethods = REFUND_METHODS.filter((method) => permittedMethods.includes(method));

  return (
    <RefundMethodField
      order={order}
      refundMethods={allowedMethods}
      name="refund_method"
      value={refund_method ?? ''}
      onChange={(value) => handleValueChange({ target: { name: 'refund_method', value } })}
      label={false}
      required={false}
      size="small"
      optionLabels={hasLatitudePayment ? { [REFUND_METHOD_MANUAL]: 'Latitude Manual Refund' } : undefined}
      sx={{
        '& .MuiRadio-root': {
          color: 'text.secondary',
          '&.Mui-checked': { color: 'text.primary' },
        },
        [`& .MuiFormControlLabel-root:not([data-testid="refundMethod-${REFUND_METHOD_MANUAL}"])`]: { mr: 2.5 },
      }}
    />
  );
}
